<template>
  <div class="foot-nav">
    <div
      v-for="(item, index) in list"
      :key="index"  
      @click="switchTab(item)" 
      class="tab-bar-item">
        <div class="img-box">
        <img :src="selected === index ? item.selectedIconPath : item.iconPath">
        </div>
        <span :class="selected === index ? 'selectedColor' : 'color'">{{item.text}}</span>
    </div>
  </div>
</template>
<script>
export default {
    name: '',
    data() {
        return {
             selected: 1,
             list: [
                {
                    pagePath: "/pages/healthShop/healthShop",
                    iconPath: require("../assets/image/status.png"),
                    selectedIconPath: require("../assets/image/statusOn.png"),
                    text: "健康之家",
                    show: true
                },{
                    pagePath: "/pages/records/records",
                    text: "健康档案",
                    iconPath: require("../assets/image/health.png"),
                    selectedIconPath: require("../assets/image/healthOn.png"),
                    show: true
                },
                // {
                //     pagePath: "/pages/scanCode/scanCode",
                //     text: "扫码检测",
                //     iconPath: require("../assets/image/scancode.png"),
                //     selectedIconPath: require("../assets/image/scancode.png"),
                //     show: false
                // },
                {
                    pagePath: "/pages/invitationTest/invitationTest",
                    text: "邀约检测",
                    iconPath: require("../assets/image/invitation.png"),
                    selectedIconPath: require("../assets/image/invitationOn.png"),
                    show: true
                },
                {
                    pagePath: "/pages/my/my",
                    text: "个人信息",
                    iconPath: require("../assets/image/my.png"),
                    selectedIconPath: require("../assets/image/myOn.png"),
                    show: true
                },
            ],
        }
    },
    methods: {
        switchTab(item) {
            window.wx.miniProgram.switchTab({ url: item.pagePath});
        }
    },
}
</script>
<style lang="scss" scoped>
.foot-nav {
  width:100%;
  height:110px;
  position: fixed;
  bottom: 0;
  z-index: 9999;
  border-top:2px solid #f4f4f4;
  box-sizing:border-box;
  color:#999;
  background:#fff;
  box-shadow:0px -5px 10px rgba(209, 209, 209, 0.3);
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.foot-nav .tab-bar-item {
  position:relative;
  width:20%;
  // height:110px;
  display: inline-block;
  text-align: center;
  bottom: 0px;
  font-size: 28px;
}
.foot-nav .tab-bar-item .img-box {
  top: 0px;
  position: relative;
}
// .foot-nav .tab-bar-item:nth-child(3) .img-box {
//   top: 2px;
//   position: relative;
// }
.foot-nav .tab-bar-item span{
  font-size: 24px;
  color: #999;
}
.foot-nav .tab-bar-item span.selectedColor{
  color:#1B84E3 ;
}
.foot-nav .tab-bar-item img {
  display: block;
  width:47px;
  height:40px;
  margin:0 auto;
}
// .foot-nav .tab-bar-item:nth-child(3) .img-box img{
//   width: 100px;
//   height: 100px;
//   border-radius: 50%;
// }
</style>